import useTheme from "@mui/material/styles/useTheme";
import Toolbar from "@mui/material/Toolbar";
import AppBar from "@mui/material/AppBar";

const Header = ({hero = null, menu = null, toolbarSx = {}}) => {
    const theme = useTheme();

    return (
        <AppBar
            position="relative"
            sx={{
                zIndex: theme.zIndex.drawer + 1,
                boxShadow: 0,
            }}
        >
            <Toolbar
                disableGutters
                sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    ...toolbarSx,
                }}
            >
                {hero}

                {menu ? menu : null}
            </Toolbar>
        </AppBar>
    );
};

export default Header;
